import MenuDefault from "grandus-lib/components/menu/Menu.default";
export default MenuDefault;